import { Collection } from 'modules/core/lib/mobx-rest'

import EmployeePermission from 'modules/shift_management/store/api/models/EmployeePermission'

class EmployeesPermissions extends Collection<EmployeePermission> {
  get cacheKey(): string {
    return 'employeesPermissions'
  }
  model() {
    return EmployeePermission
  }
}

const singleton: EmployeesPermissions = new EmployeesPermissions()

export default singleton
